import { useLocation } from "react-router-dom";

import SiteFooter from "@/components/SiteFooter";
import SiteHeader from "@/components/SiteHeader";

// Full-screen auth pages render without the shared chrome (they have their own AuthShell). Every
// other page — including the landing ("/") — gets the single shared header so it's consistent.
const BARE_ROUTES = ["/login", "/register", "/forgot-password"];

// The full marketing footer is landing-only ("/"). Every other page still gets a slim legal strip
// (© LatentForce · Privacy · Terms) so the legal links are reachable site-wide.
const FULL_FOOTER_ROUTES = ["/"];

export default function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = useLocation().pathname;

  if (BARE_ROUTES.includes(pathname)) return <>{children}</>;

  const fullFooter = FULL_FOOTER_ROUTES.includes(pathname);
  // Reserve viewport height for the header (4.5rem) plus the footer — the full footer is tall
  // (~5rem), the slim legal strip short (~3rem) — so short pages don't leave a blank gap.
  const minH = fullFooter ? "min-h-[calc(100vh-9.5rem)]" : "min-h-[calc(100vh-7.5rem)]";

  return (
    <>
      <SiteHeader />
      <div className={minH}>{children}</div>
      <SiteFooter minimal={!fullFooter} />
    </>
  );
}
